import { extendMoment } from 'moment-range';
import Moment from 'moment-timezone';

const moment = extendMoment(Moment);

// eslint-disable-next-line no-underscore-dangle
// Use dynamic institution timezone if available, otherwise fallback to initial state
const institutionTimezone =
    window.config?.institution?.timezone ||
    window.__INITIAL_STATE__?.InstitutionSettings?.timezone ||
    'America/Los_Angeles';
moment.tz.setDefault(institutionTimezone);

moment.fn.setTimeFromString = function (timeString) {
    const [hour, minute = 0, second = 0] = timeString.split(':');

    this.set({
        hour,
        minute,
        second,
    });

    return this;
};

export default moment;
